module.exports = __webpack_public_path__ + "static/img/text2.4aa7721.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/text2.png
// module id = 208c
// module chunks = 1